import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppLayout from "@/pages/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Rules from "@/pages/Rules";
import Catalog from "@/pages/Catalog";
import Generator from "@/pages/Generator";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Admin from "@/pages/Admin";
import Connectors from "@/pages/Connectors";
import IacPage from "@/pages/Iac";
import Patrice from "@/pages/Patrice";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center bg-white text-slate-500">
        <span className="font-mono text-xs tracking-widest uppercase">Loading…</span>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function DocumentTitle() {
  const { user } = useAuth();
  useEffect(() => {
    const workspace = user && user.company ? user.company.trim() : "";
    document.title = workspace ? `Toastern | ${workspace}` : "Toastern";
  }, [user]);
  return null;
}

export default function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <DocumentTitle />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/app"
            element={
              <Protected>
                <AppLayout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="rules" element={<Rules />} />
            <Route path="catalog" element={<Catalog />} />
            <Route path="generate" element={<Generator />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:id" element={<ProjectDetail />} />
            <Route path="connectors" element={<Connectors />} />
            <Route path="iac" element={<IacPage />} />
            <Route path="patrice" element={<Patrice />} />
            <Route path="admin" element={<Admin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
    </ThemeProvider>
  );
}
